export default __webpack_public_path__ + "static/media/elena.fb497523.png";